export function Header(props: any) {
  return (
    <div>
      <h4 className="mt-0 header-title fs-4 text-dark">
        Lista de {props.title}
      </h4>
      <p className="fs-6 text-dark">
        {props.pronoun && props.pronoun === "a"
          ? " Aqui são listadas todas as suas "
          : " Aqui são listados todos os seus "}
        {props.title.toLowerCase()}
      </p>
      <br />
    </div>
  );
}
